import { useReducer } from "react"

type LayoutState = {
  // null means nothing has dispatched a width yet
  layoutWidth: string | null
  embedded: boolean
}

type LayoutAction = { type: "setLayoutWidth"; payload: string | null }

export function useLayoutReducer(
  initialLayoutState: LayoutState = {
    layoutWidth: null,
    embedded: false,
  },
) {
  function reducer(state: LayoutState, action: LayoutAction): LayoutState {
    switch (action.type) {
      case "setLayoutWidth":
        return {
          ...state,
          layoutWidth: action.payload,
        }
    }
  }

  return useReducer(reducer, initialLayoutState)
}
